import { useTranslation } from 'react-i18next';
import { GoldThread } from '@/components/brand/GoldThread';

export default function WhyUsPage() {
  const { t } = useTranslation();

  const items = [
    t('why.items.fur'),
    t('why.items.eco'),
    t('why.items.express'),
    t('why.items.pricing'),
    t('why.items.hygiene'),
    t('why.items.guarantee'),
  ];

  return (
    <>
      <section className="bg-bone">
        <div className="container pt-20 pb-16 md:pt-32 md:pb-20">
          <div className="grid grid-cols-12 gap-y-10 gap-x-6">
            <div className="col-span-12 md:col-span-8 animate-fade-up">
              <div className="flex items-center gap-4 mb-6">
                <GoldThread />
                <span className="eyebrow">{t('nav.why_us')}</span>
              </div>
              <h1 className="font-display text-d-2 text-ink"
                  style={{ fontVariationSettings: "'opsz' 144, 'wght' 500" }}>
                {t('why.title')}
              </h1>
            </div>
          </div>
        </div>
      </section>

      <section className="container pb-24 md:pb-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-line">
          {items.map((item, i) => (
            <div key={item} className="bg-bone p-10 md:p-12 min-h-[16rem] flex flex-col">
              <span className="font-display text-gold text-2xl"
                    style={{ fontVariationSettings: "'opsz' 144, 'wght' 400' " }}>
                {String(i + 1).padStart(2, '0')}
              </span>
              <p className="mt-auto font-display text-2xl md:text-3xl text-ink leading-tight"
                 style={{ fontVariationSettings: "'opsz' 90, 'wght' 500" }}>
                {item}
              </p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
